import { HeatMapAnalyticsActivitySchemaName } from '../heat-maps-analytics-activity.enum';

export enum TeamAnalyticsActivitySegments {
  sunday = 'TeamAnalyticsActivity.sunday',
  monday = 'TeamAnalyticsActivity.monday',
  tuesday = 'TeamAnalyticsActivity.tuesday',
  wednesday = 'TeamAnalyticsActivity.wednesday',
  thursday = 'TeamAnalyticsActivity.thursday',
  friday = 'TeamAnalyticsActivity.friday',
  saturday = 'TeamAnalyticsActivity.saturday',
}

export enum TeamAnalyticsActivityV2Segments {
  sunday = 'TeamAnalyticsActivityV2.sunday',
  monday = 'TeamAnalyticsActivityV2.monday',
  tuesday = 'TeamAnalyticsActivityV2.tuesday',
  wednesday = 'TeamAnalyticsActivityV2.wednesday',
  thursday = 'TeamAnalyticsActivityV2.thursday',
  friday = 'TeamAnalyticsActivityV2.friday',
  saturday = 'TeamAnalyticsActivityV2.saturday',
}

export enum HeatMapAnalyticsActivitySegments {
  sunday = `${HeatMapAnalyticsActivitySchemaName}.sunday`,
  monday = `${HeatMapAnalyticsActivitySchemaName}.monday`,
  tuesday = `${HeatMapAnalyticsActivitySchemaName}.tuesday`,
  wednesday = `${HeatMapAnalyticsActivitySchemaName}.wednesday`,
  thursday = `${HeatMapAnalyticsActivitySchemaName}.thursday`,
  friday = `${HeatMapAnalyticsActivitySchemaName}.friday`,
  saturday = `${HeatMapAnalyticsActivitySchemaName}.saturday`,
}
